/**
 * A number someone can dial: international with `+` and a country code, or
 * national with the trunk zero (`089 …`, `0171 …`, `(089) …`), written with
 * the separators people actually type (`+49 (0)89 / 123-45.67`), and between
 * 6 and 15 digits — fewer is a typo or an extension, more than E.164 allows is
 * not a phone number. The prefix is what tells a number from a string of
 * digits (`194155555` has neither, so nobody could dial it back); beyond that
 * there are no country rules, so a visitor from abroad is not turned away by a
 * German format.
 *
 * Written as an HTML `pattern` so the field's native validation and the
 * script's check are one rule; the attribute anchors it to the whole value.
 * Brackets, slash and hyphen are escaped because browsers compile `pattern`
 * with the `v` flag, which rejects them bare inside a class.
 */
export const PHONE_INPUT_PATTERN = '(?=(?:\\D*\\d){6})(?!(?:\\D*\\d){16})(?:\\+[1-9]|\\(?0)[\\d\\s\\(\\)\\/.\\-]*';

/** The message the browser shows for a number that fails the pattern. */
export const PHONE_INPUT_TITLE =
    'Bitte geben Sie eine Telefonnummer mit Vorwahl ein, z. B. 089 123456 oder +49 89 123456.';

const PHONE_PATTERN = new RegExp(`^(?:${PHONE_INPUT_PATTERN})$`, 'v');

export const isValidPhone = (value: string) => PHONE_PATTERN.test(value.trim());
